export default {
    namespaced: true,
    state: {
        dataSource:[]
    },
    getters: {
        getDataSource: state => state.dataSource
    },
    mutations: {
        setDataSource(state,data){
            console.log(data)
            state.dataSource = data
        },
    },
    actions: {
        setDataSource(state,data){
            console.log(data)
            state.dataSource = data
        },
    }
}